export default __webpack_public_path__ + "static/media/Copper_Dec20_Rank.e83fb135.png";